import React from "react";
import "../../styles/OffersSection/OffersCards.scss";
import { Offer, OfferCard } from "./OffersCard";
import { useTranslation } from "react-i18next";

const Offers: React.FC = () => {
  const { t } = useTranslation();

  const Offers: Offer[] = [
    {
      id: 1,
      name: t("virtualSpaces"),

      description: t("virtualSpaces_desc"),
    },
    {
      id: 2,
      name: t("sharedOffice"),

      description: t("sharedOffice_desc"),
    },
    {
      id: 3,
      name: t("privateOffice"),

      description: t("privateOffice_desc"),
    },
    {
      id: 4,
      name: t("conferenceRoom"),

      description: t("conferenceRoom_desc"),
    },
  ];

  return (
    <div className="Offers">
      {Offers.map((Offer, index) => (
        <OfferCard
          key={index}
          title={Offer.name}
          index={Offer.id}
          description={Offer.description}
        />
      ))}
    </div>
  );
};

export default Offers;
